import { createAuthClient } from "better-auth/react";

/**
 * Same-origin in dev (via the Vite proxy) and in production (via nginx), so
 * session cookies are first-party in both.
 */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
});
